module.exports = __webpack_public_path__ + "static/media/trash.95f7b76c.svg";